import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#fff",
          fontWeight: 700,
          fontSize: 16,
          borderRadius: "4px",
          textTransform: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: "pointer",
          textDecoration: "none",
          textTransform: "none",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontSize: "0.8rem",
        },
        input: {
          border: "1px solid #2AAAA6",
          borderWidth: 0,
          padding: "12px",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#2AAAA6",
    },
    secondary: {
      main: "#777777",
    },
    error: {
      main: red.A400,
    },
    text: {
      secondary: "#777777",
    },
  },
});

export default theme;
